import {CheckboxField, SelectField, TextButtonField} from "@/core/components/form";
export default {
    components:{
        CheckboxField,
        SelectField,
        TextButtonField
    },
    data(){
        return {
            // Search
            items: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 5,
            pageOptions: [
                { value: 5, text: "5 élements" },
                { value: 10, text: "10 élements" },
                { value: 15, text: "15 élements" },
                { value: 50, text: "50 élements" }
            ],
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            infoModal: {
                id: 'info-modal',
                title: '',
                content: ''
            }
        }
    },
    methods: {
        //Search
        setItems(items){
            this.items = items
            this.totalRows = items.length
        },
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = Object.assign({}, item)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        }
    },
}
